import { Box, Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import React from 'react';
import { WarningIcon } from 'src/components/common-modals/page-leave-confirmation';

export interface WarningModalProps {
  open: boolean;
  title: string;
  message: string;
  buttonText?: string;
  onClose: () => void;
  cancelBtn: string;
  handleSaveBtn: () => void;
  primaryCTA?: boolean;
  testIds?: { confirm?: string; cancel?: string };
}

const WarningModal: React.FC<WarningModalProps> = ({
  open,
  title,
  message,
  buttonText = 'Got it',
  cancelBtn,
  onClose,
  handleSaveBtn,
  primaryCTA = false,
  testIds,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="warning-modal-title"
      aria-describedby="warning-modal-description"
    >
      <Box p={1}>
        <>
          <DialogContent>
            <Box sx={{ display: 'flex' }}>
              <Box>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    height: '100%',
                    marginRight: '12px',
                  }}
                >
                  <WarningIcon />
                </div>
              </Box>
              <Box>
                <Box>
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    gutterBottom
                  >
                    {title}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Typography
                    variant="body2"
                    sx={{ color: 'text.secondary', mb: 3 }}
                  >
                    {message}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </DialogContent>
          <DialogActions>
            {cancelBtn && (
              <Button
                variant="text"
                autoFocus
                sx={{ color: '#111927' }}
                onClick={onClose}
                data-testid={testIds?.cancel}
              >
                {cancelBtn}
              </Button>
            )}
            <Button
              autoFocus
              variant="contained"
              sx={
                primaryCTA
                  ? {}
                  : {
                      bgcolor: '#f57c00',
                      '&:hover': { bgcolor: '#ef6c00' },
                      color: '#fff',
                    }
              }
              onClick={handleSaveBtn}
              data-testid={testIds?.confirm}
            >
              {buttonText}
            </Button>
          </DialogActions>
        </>
      </Box>
    </Dialog>
  );
};

export default WarningModal;
